/* Ypresets before/after slider + inline add-to-cart. No dependencies. */
(function(){
  function initSlider(el){
    if(el.__ba)return; el.__ba=1;
    var range=el.querySelector('input[type=range]');
    var set=function(v){v=Math.max(0,Math.min(100,v));el.style.setProperty('--pos',v+'%');el.classList.toggle('hide-b',v<24);el.classList.toggle('hide-a',v>76);if(range&&+range.value!==Math.round(v))range.value=Math.round(v);};
    var rect=null,dragging=false,startX=0,startY=0,decided=false,horiz=false;
    var posFrom=function(x){rect=rect||el.getBoundingClientRect();return (x-rect.left)/rect.width*100;};
    el.addEventListener('pointerdown',function(e){
      if(e.button>0)return; rect=el.getBoundingClientRect(); dragging=true; decided=e.pointerType==='mouse'; horiz=decided;
      startX=e.clientX; startY=e.clientY; el.classList.add('is-active');
      if(horiz){set(posFrom(e.clientX));try{el.setPointerCapture(e.pointerId)}catch(_){}}
    });
    el.addEventListener('pointermove',function(e){
      if(!dragging)return;
      if(!decided){var dx=Math.abs(e.clientX-startX),dy=Math.abs(e.clientY-startY);if(dx<4&&dy<4)return;decided=true;horiz=dx>dy;if(horiz){try{el.setPointerCapture(e.pointerId)}catch(_){}}}
      if(horiz){e.preventDefault();set(posFrom(e.clientX));}
    });
    var end=function(e){
      if(dragging&&!decided&&e&&e.type==='pointerup'){set(posFrom(e.clientX));}
      dragging=false;rect=null;el.classList.remove('is-active');
    };
    el.addEventListener('pointerup',end);el.addEventListener('pointercancel',function(){dragging=false;rect=null;el.classList.remove('is-active');});
    if(range){range.addEventListener('input',function(){set(+range.value)});}
    set(range?+range.value:50);
  }
  function initForm(f){
    if(f.__yp)return; f.__yp=1;
    f.addEventListener('submit',function(e){
      var drawer=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
      if(!drawer||typeof drawer.renderContents!=='function'||!window.fetch)return; // normal POST to /cart/add
      e.preventDefault();
      var btn=f.querySelector('[type=submit]'); if(btn){btn.setAttribute('aria-busy','true');btn.disabled=true;}
      var fd=new FormData(f);
      try{fd.append('sections',drawer.getSectionsToRender().map(function(s){return s.id}));fd.append('sections_url',window.location.pathname);}catch(_){}
      fetch((window.routes&&window.routes.cart_add_url||'/cart/add')+'',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/javascript'},body:fd})
        .then(function(r){return r.json()})
        .then(function(res){
          if(res.status){f.submit();return;}
          try{drawer.classList.contains('is-empty')&&drawer.classList.remove('is-empty');drawer.renderContents(res);}catch(err){window.location='/cart';}
        })
        .catch(function(){f.submit();})
        .finally(function(){if(btn){btn.removeAttribute('aria-busy');btn.disabled=false;}});
    });
  }
  function boot(){
    document.querySelectorAll('[data-yp-ba]').forEach(initSlider);
    document.querySelectorAll('form[data-yp-atc]').forEach(initForm);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
